import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ComingSoon from './ComingSoon';
import Privacy from './pages/Privacy';
import About from './pages/About';
import Contact from './pages/Contact';
import Header from './components/Header';
import WhatsAppFab from './components/WhatsAppFab';
import ProtectedRoute from './components/ProtectedRoute';
import Account from './features/account/Account';
import PurchasedEsimDetail from './features/account/PurchasedEsimDetail';
import Home from './features/home/Home';
import NotFound from './features/notfound/NotFound';
import EsimDetail from './features/home/EsimDetail';
import PlanDetail from './features/home/PlanDetail';
import OrderSuccess from './features/order/OrderSuccess';
import EsimGuide from './features/guide/EsimGuide';
import Checkout from './features/checkout/Checkout';
import Login from './features/auth/Login';
import Signup from './features/auth/Signup';
import VerifyEmail from './features/auth/VerifyEmail';
import ForgotPassword from './features/auth/ForgotPassword';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { isWebViewMode } from './utils/webviewUtils';
import './i18n';

function App() {
  useEffect(() => {
    // WebView modunda body'ye class ekle
    if (isWebViewMode()) {
      document.body.classList.add('webview-mode');
    } else {
      document.body.classList.remove('webview-mode');
    }
  }, []);

  return (
    <Router>
      {/* AuthProvider, Router İÇİNDE olmalı (useNavigate gerektirir) */}
      <AuthProvider>
       <CurrencyProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/esim/plan/:bundleId/:refillId" element={<PlanDetail />} />
          <Route path="/esim/:type/:id" element={<EsimDetail />} />
          <Route path="/order/success" element={<OrderSuccess />} />
          <Route path="/esim-guide" element={<EsimGuide />} />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/esim/:orderId"
            element={
              <ProtectedRoute>
                <PurchasedEsimDetail />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* Eski koyu temalı sayfalar — global Header yerine kendi başlığını
              yalnızca bu route'larda render eder (yenilemede flash önlenir). */}
          <Route path="/soon" element={<><Header /><ComingSoon /></>} />
          <Route path="/privacy" element={<><Header /><Privacy /></>} />
          <Route path="/about" element={<><Header /><About /></>} />
          <Route path="/contact" element={<><Header /><Contact /></>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* Her ekranda sağ-altta sabit WhatsApp destek butonu */}
        <WhatsAppFab />
       </CurrencyProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
